/* eslint-disable react/no-unknown-property */
import { useGLTF } from '@react-three/drei';

export default function Model() {
  const { scene: model } = useGLTF('model/reproduction.glb');

  return <primitive object={model} position={[0.6, -0.4, 0.2]} />;
}
